export default "__VITE_ASSET__f_pO7RTx__"